import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 19C14.45 19 13.9793 18.8043 13.588 18.413C13.196 18.021 13 17.55 13 17V7C13 6.45 13.196 5.97933 13.588 5.588C13.9793 5.196 14.45 5 15 5H17C17.55 5 18.021 5.196 18.413 5.588C18.8043 5.97933 19 6.45 19 7V17C19 17.55 18.8043 18.021 18.413 18.413C18.021 18.8043 17.55 19 17 19H15ZM7 19C6.45 19 5.97933 18.8043 5.588 18.413C5.196 18.021 5 17.55 5 17V7C5 6.45 5.196 5.97933 5.588 5.588C5.97933 5.196 6.45 5 7 5H9C9.55 5 10.021 5.196 10.413 5.588C10.8043 5.97933 11 6.45 11 7V17C11 17.55 10.8043 18.021 10.413 18.413C10.021 18.8043 9.55 19 9 19H7ZM15 17H17V7H15V17ZM7 17H9V7H7V17Z",
		fill: "currentColor"
	})
});
export default SvgPause;
